import { FC } from 'react';
import styles from './index.module.less';
import { StatusAndOption } from '@pro/420CheckIn/Interactive/StatusAndOption';
import { ClearRecord } from '@pro/420CheckIn/ClearRecord';
import { CheckInResult } from '@pro/420CheckIn/Interactive/CheckInResult';
import { Trans } from 'base/utils/i18n';

export const Interactive: FC = () => {
    return (
        <div className={styles.interactive}>
            <div className="wrapper">
                <div className={styles.titles}>
                    <Trans
                        i18nKey={'web_checkin_titles'}
                        components={{
                            line1: <p className={styles.line1}/>,
                            line2: <p className={styles.line2}/>,
                            line3: <p className={styles.line3}/>,
                        }}
                    />
                </div>

                <StatusAndOption/>

                <CheckInResult/>

                <ClearRecord/>
            </div>
        </div>
    )
};
